module.exports = __webpack_public_path__ + "img/guide-10.0f2e3de5.jpg";